import React from 'react';
import {Button, Card, Collapse, Spin, Tabs,Tooltip,Icon} from 'antd';
import {fetchEvt, replaceEvtInEvts} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import EvtViewBaseForm from "./EvtViewBaseForm";
import evtConfigDes from './EvtConfigDes'
import EvtViewConfigForm from "./EvtViewConfigForm";
import EvtViewRegisterForm from "./EvtViewRegisterForm";
import canvasToImage from 'canvas-to-image';
import EvtViewGuestForm from "./EvtViewGuestForm";
import EvtViewGuesLibrarys from "./EvtViewGuesLibrarys";
import EvtViewAgendaForm from "./EvtViewAgendaForm";
import EvtViewPosterForm from "./EvtViewPosterForm";
import EvtViewVideoForm from "./EvtViewVideoForm";
import EvtViewBriefForm from "./EvtViewBriefForm";
import EvtViewTicketingForm from "./EvtViewTicketingForm";
import EvtViewCheckinpointForm from "./EvtViewCheckinpointForm";
import EvtViewCheckinAction from "./EvtViewCheckinAction";
import EvtViewCheckinMusic from "./EvtViewCheckinMusic";
import EvtViewOrganizerCheckinAction from "./EvtViewOrganizerCheckinAction";
import EvtViewSignUpAction from "./EvtViewSignUpAction";
import EvtViewSignUpAddress from "./EvtViewSignUpAddress";
import EvtViewRegistrationForm from "./EvtViewRegistrationForm";
import EvtViewCheckinForm from "./EvtViewCheckinForm";
import EvtViewCheckinCredit from "./EvtViewCheckinCredit";
import EvtViewQrcodeForm from "./EvtViewQrcodeForm";
import EvtViewEvtModeForm from "./EvtViewEvtModeForm";
import EvtViewPromoteForm from "./EvtViewPromoteForm";
import EvtViewWxContactForm from "./EvtViewWxContactForm";
// import EvtViewCheckinpointQrcodeForm from "./EvtViewCheckinpointQrcodeForm";
import EvtViewCheckinpointQrcode from "./EvtViewCheckinpointQrcode";
import {isVasValidity} from "../../services/global";
import PurchaseServiceTips from "../PurchaseServiceTips";


class EvtView extends React.Component {

    constructor(props) {
        super(props);
        this.pstView =null;
        this.state = {
            evtId: props.evtId,
            baseAreaEditable: false,    //基本信息
            invitationEditable: false,  //邀请函(背景音乐和样式)
            invitationConfigEditable: false,    //邀请函相关配置参数
            checkinConfigEditable: false,   //签到相关配置参数
            registerConfigEditable: false,  //报名相关配置参数
            sendAttendSignInConfirmEditable: false,  //报名相关配置参数
            sendAllotReceiverEditable: false,  //报名相关配置参数
            registerEditable: false,    //报名报名起止日期)
            guestEditable: false,   //嘉宾
            addGuestEditable: false,   //嘉宾
            agendaEditable: false,  //流程
            posterEditable: false,  //海报
            videoEditable: false,  //视频
            briefEditable: false,  //详情
            organizerCheckinAction: false,  //主办方签到动作
            checkinAction: false,  //签到动作
            checkinMusic: false,  //签到音乐
            signUpAction: false,  //签到动作
            signUpShareCode: false,  //签到动作
            signUpAddress: false,  //签到动作
            checkinCredit: false,  //签到动作
            checkinpointEditable: false,    //签到点
            ticketEditable: false,      //票种
            ticketEditableDiscount: false,      //票种折扣
            registrationEditable: false,  //报名表
            checkinFromEditable: false,  //签到表
            qrcodeEditable: false,  //二维码
            sendAttendConfirm: false,  //二维码
            checkinpointQrcodeEditable: false,  //二维码
            evtModeEditable: false,  //二维码
            promoteEditable: false,  //二维码
            wxContactEditable: false,  //客服配置
            tabsActiveKey: this.props.tabsActiveKey,
            vaild:false,
        }
    }

    componentDidMount() {
        isVasValidity(1002, (vaild) => {
            this.setState({
                vaild:vaild,
            })
        })
    }

    fetchData = (fetchThenFunc = () => this.props.replaceEvtInEvts(this.state.evtId, this.props.evt)) => {
        if (this.state.evtId) {
            this.props.fetchEvt(this.state.evtId).then(fetchThenFunc ? fetchThenFunc : () => null);
        }
    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            baseAreaEditable: false,
            invitationEditable: false,
            invitationConfigEditable: false,
        });

        if (nextProps.evtId && this.state.evtId != nextProps.evtId) {
            this.setState({
                evtId: nextProps.evtId,
            }, () => {
                this.fetchData();
            })
        }

        if (nextProps.tabsActiveKey && this.state.tabsActiveKey != nextProps.tabsActiveKey) {
            this.setState({
                tabsActiveKey: nextProps.tabsActiveKey,
            })
        }

    }

    editableChange = (editableStatePropName, editable, dataChanged = false) => {
        const statePropObj = {};
        statePropObj[editableStatePropName] = editable;
        this.setState(statePropObj, () => {
            this.props.inEditMode(editable, this.state.tabsActiveKey)
        });
        if (!editable && dataChanged) {
            this.fetchData();
        }
    }


    tabsChange = (activeKey) => {
        this.setState({
            tabsActiveKey: activeKey
        })
    }

    downloadQR = (QRRef, fileName) => {
        canvasToImage(QRRef, {
            name: fileName,
            type: 'png',
            quality: 1
        });
    }


    render() {
        const {evt} = this.props;
        if (evt && evt.isFetching) {
            return <Spin className="full-screen-spin" spinning={true}/>
        }


        return (
            <Spin spinning={evt.isFetching}>
                <Tabs onChange={this.tabsChange} activeKey={this.state.tabsActiveKey} style={{paddingBottom: "60px"}}>
                    <Tabs.TabPane tab="基础" key="detail">
                        <EvtViewBaseForm
                            evt={evt.data}
                            editable={this.state.baseAreaEditable}
                            editableStatePropName={"baseAreaEditable"}
                            editableChange={this.editableChange}
                            evtBaseAreaExtra={
                                <div>
                                    <EvtViewVideoForm
                                    evt={evt.data}
                                    editable={this.state.videoEditable}
                                    editableStatePropName={"videoEditable"}
                                    editableChange={this.editableChange}/>
                                    <EvtViewBriefForm
                                    evt={evt.data}
                                    editable={this.state.briefEditable}
                                    editableStatePropName={"briefEditable"}
                                    editableChange={this.editableChange}/>
                                    <EvtViewPosterForm
                                    evt={evt.data}
                                    editable={this.state.posterEditable}
                                    editableStatePropName={"posterEditable"}
                                    editableChange={this.editableChange}/>
                                </div>
                            }/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="表单" key="registration">

                        <Collapse bordered={false} activeKey={['1']} >
                            <Collapse.Panel key="1" header={
                                <div>
                                    <span>报名表单
                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                                     <div>
                                                         设计报名时需要填写的字段，修改唯一字段（签到字段） <a href="https://www.kancloud.cn/seven_qdj/qdj_help_201808/737118" target="_Blank" >  详细帮助</a>
                                                     </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>
                                    <div className="toolbar-right">
                                        <Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                            e.stopPropagation();

                                            this.editableChange("registrationEditable", true)
                                        }}>
                                            编辑
                                        </Button>
                                    </div>
                                </div>}>


                                <EvtViewRegistrationForm
                                    evt={evt.data}
                                    editable={this.state.registrationEditable}
                                    editableStatePropName={"registrationEditable"}
                                    editableChange={this.editableChange}/>
                            </Collapse.Panel>
                        </Collapse>
                        {
                            evt.data.config.replenishFormEventId &&
                        <Collapse bordered={false} activeKey={['1']} style={{marginTop:20}}>
                            <Collapse.Panel key="1" header={
                                <div>
                                    <span>签到成功后补充表单
                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                设计签到成功后需要填写的字段，如：每次签到填写体温；每次巡检上传现场照片等   <a href="https://www.kancloud.cn/seven_qdj/qdj_help_201808/737119" target="_Blank" >  详细帮助</a>
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>
                                    <div className="toolbar-right">
                                        <Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                            e.stopPropagation();

                                            this.editableChange("checkinFromEditable", true)
                                        }}>
                                            编辑
                                        </Button>
                                    </div>
                                </div>}>


                                <EvtViewCheckinForm
                                    evt={evt.data}
                                    editable={this.state.checkinFromEditable}
                                    editableStatePropName={"checkinFromEditable"}
                                    editableChange={this.editableChange}/>
                            </Collapse.Panel>
                        </Collapse>}

                    </Tabs.TabPane>
                    <Tabs.TabPane tab="嘉宾日程" key="guestAndAgenda">
                        <Card bodyStyle={{padding: "0"}}>
                            <Collapse bordered={false} activeKey={['1', '2']}>
                                <Collapse.Panel key="1" header={
                                    <div>
                                        <span>嘉宾{evt.data.guests && evt.data.guests.length > 0 ? `（${evt.data.guests.length}）` : ''}
                                            <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                <div style={{maxHeight:700,overflow:'auto'}}>
                                                    <img style={{width: 450}} src='https://img.qdj8.cn/13.jpg'/>
                                                </div>
                                            }>
                                             <span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                        </Tooltip>
                                        </span>
                                        <div className="toolbar-right">
                                            <Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                                e.stopPropagation();
                                                this.editableChange("addGuestEditable", true)
                                            }}>嘉宾库选择</Button>
                                            <Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                                e.stopPropagation();
                                                this.editableChange("guestEditable", true)
                                            }}>编辑</Button>
                                        </div>
                                    </div>}>

                                    <EvtViewGuestForm
                                        evt={evt.data}
                                        editable={this.state.guestEditable}
                                        editableStatePropName={"guestEditable"}
                                        editableChange={this.editableChange}/>
                                    <EvtViewGuesLibrarys
                                        evt={evt.data}
                                        editable={this.state.addGuestEditable}
                                        editableStatePropName={"addGuestEditable"}
                                        editableChange={this.editableChange}/>
                                </Collapse.Panel>
                                <Collapse.Panel key="2" header={
                                    <div>
                                        <span>日程{evt.data.agenda && evt.data.agenda.length > 0 ? `（${evt.data.agenda.length}）` : ''}
                                            <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                <div style={{maxHeight:700,overflow:'auto'}}>
                                                    <img style={{width: 450}} src='https://img.qdj8.cn/14.jpg'/>
                                                </div>
                                            }>
                                             <span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                        </Tooltip>
                                        </span>
                                        <div className="toolbar-right"
                                        ><Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                            e.stopPropagation();
                                            this.editableChange("agendaEditable", true)
                                        }}>编辑</Button>
                                        </div>
                                    </div>}>
                                    <EvtViewAgendaForm
                                        evt={evt.data}
                                        editable={this.state.agendaEditable}
                                        editableStatePropName={"agendaEditable"}
                                        editableChange={this.editableChange}/>
                                </Collapse.Panel>
                            </Collapse>
                        </Card>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="票务" key="ticketing">
                        <EvtViewEvtModeForm
                            evt={evt.data}
                            editable={this.state.evtModeEditable}
                            editableStatePropName="evtModeEditable"
                            editableChange={this.editableChange}/>
                        <Collapse bordered={false} activeKey={['1']}>
                            <Collapse.Panel key="1" header={
                                <div>
                                    <span>
                                        票种{evt.data.tickets && evt.data.tickets.length > 0 ? `（${evt.data.tickets.length}）` : ''}
                                        &nbsp;&nbsp;<span>（编辑票务类型，限制报名人数）
                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                是否收费都可以编辑票务，报名默认一人只能选择一种且一张，购票模式可以选择多种多张，支持优惠劵；设置票数可以限制报名人数 <a href="https://www.kancloud.cn/seven_qdj/qdj_help_201808/737197" target="_Blank" >  详细帮助</a>
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>
                                    </span>
                                    <div className="toolbar-right"><Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                        e.stopPropagation();
                                        this.editableChange("ticketEditable", true)
                                    }}>编辑</Button>
                                    </div>
                                </div>}>
                                <EvtViewTicketingForm
                                    evt={evt.data}
                                    editable={this.state.ticketEditable}
                                    editableStatePropName={"ticketEditable"}
                                    editableChange={this.editableChange}/>
                            </Collapse.Panel>
                        </Collapse>

                    </Tabs.TabPane>
                    {/*<TabPane tab="邀请函" key="invitation">*/}

                    {/*<div className="evt-area">*/}

                    {/*<div className="evt-base-area area-turn">*/}
                    {/*<EvtViewInvitationForm*/}
                    {/*evt={evt.data}*/}
                    {/*editable={this.state.invitationEditable}*/}
                    {/*editableChange={this.editableChange}/>*/}
                    {/*</div>*/}
                    {/*<div className="evt-banner-area area-turn">*/}
                    {/*<EvtViewConfigForm*/}
                    {/*evt={evt.data}*/}
                    {/*editable={this.state.invitationConfigEditable}*/}
                    {/*confDesArr={[*/}
                    {/*evtConfigDes.hidePersonalInfo*/}
                    {/*]}*/}
                    {/*editableStatePropName="invitationConfigEditable"*/}
                    {/*editableChange={this.editableChange}/>*/}
                    {/*</div>*/}
                    {/*</div>*/}

                    {/*</TabPane>*/}
                    <Tabs.TabPane tab="报名" key="registration-config">

                        <div className="evt-area" style={{minHeight: "740px"}}>

                            <div className="evt-base-area area-turn">


                                <EvtViewRegisterForm
                                    evt={evt.data}
                                    editable={this.state.registerEditable}
                                    editableChange={this.editableChange}/>
                                <EvtViewSignUpAddress
                                    evt={evt.data}
                                    editable={this.state.signUpAddress}
                                    editableChange={this.editableChange}/>
                                <EvtViewConfigForm
                                    evt={evt.data}
                                    editable={this.state.signUpShareCode}
                                    confDesArr={[
                                        evtConfigDes.enabledShareCode,
                                        evtConfigDes.mustShareCode,
                                    ]}
                                    editableStatePropName="signUpShareCode"
                                    editableChange={this.editableChange}/>
                                <EvtViewSignUpAction
                                    evt={evt.data}
                                    editable={this.state.signUpAction}
                                    editableChange={this.editableChange}/>    
                                <EvtViewConfigForm
                                    type='sendAttendConfirm'
                                    evt={evt.data}
                                    editable={this.state.sendAttendConfirm}
                                    confDesArr={[
                                        evtConfigDes.sendAttendConfirm,
                                    ]}
                                    editableStatePropName="sendAttendConfirm"
                                    editableChange={this.editableChange}/>


                            </div>
                            <div className="evt-banner-area area-turn">

                                <EvtViewConfigForm
                                    evt={evt.data}
                                    editable={this.state.registerConfigEditable}
                                    confDesArr={[
                                        evtConfigDes.allowBatchAttend,
                                        evtConfigDes.validateAttendee,
                                        evtConfigDes.hideAttendee,
                                        evtConfigDes.enableInviteeStatistics,
                                        evtConfigDes.approveAttendee,
                                        evtConfigDes.avatarMandatory,
                                        evtConfigDes.faceOpen,
                                        evtConfigDes.allowAttendeeEditForm,
                                        evtConfigDes.onlyWxSignUp,
                                        evtConfigDes.enableAttendeeInvoice,
                                        evtConfigDes.enableComment,
                                    ]}
                                    editableStatePropName="registerConfigEditable"
                                    editableChange={this.editableChange}/>



                            </div>
                        </div>

                    </Tabs.TabPane>
                    <Tabs.TabPane tab="签到" key="checkin">
                        <div className="evt-area">

                            <div className="evt-base-area area-turn">
                                <Collapse className={'collapse-checkin'} bordered={false} activeKey={['1', '2']} style={{marginBottom:16}}>
                                    <Collapse.Panel key="1" header={
                                        <div>
                                            <span>签到点管理{evt.data.checkinpoints && evt.data.checkinpoints.length > 0 ? `（${evt.data.checkinpoints.length}）` : ''}
                                                <span>&nbsp;

                                                    <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                             mouseEnterDelay={0.3} title={
                                                        <div>
                                                            签到点：相当于分会场，一个活动可设置多个签到点（可设定签到GPS范围，时间，周期间隔，关联子账号等） <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/845029" target="_Blank" >  详细帮助</a>
                                                        </div>
                                                    }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>
                                            </span>
                                            <div className="toolbar-right"
                                            ><Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                                e.stopPropagation();
                                                this.editableChange("checkinpointEditable", true)
                                            }}>编辑</Button>
                                            </div>
                                        </div>}>
                                        <EvtViewCheckinpointForm
                                            evt={evt.data}
                                            editable={this.state.checkinpointEditable}
                                            editableStatePropName={"checkinpointEditable"}
                                            editableChange={this.editableChange}/>


                                    </Collapse.Panel>
                                    {/*<Panel key="2" className="table-panel" header={
                                        <div>
                                            <span>最近的签到记录</span>
                                            <div className="toolbar-right"
                                            ><Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}}>查看更多</Button>
                                            </div>
                                        </div>}>
                                        <Table size="small" columns={[{
                                            title: '时间',
                                            dataIndex: 'name',
                                        }, {
                                            title: '签到人',
                                            dataIndex: 'age',
                                        }, {
                                            title: '电话',
                                            dataIndex: 'address',
                                        }, {
                                            title: '类型',
                                            dataIndex: 'type',
                                        }, {
                                            title: '签到点',
                                            dataIndex: 'checkinpoint',
                                        }]} dataSource={[]}/>
                                    </Panel>*/}

                                </Collapse>
                                <EvtViewCheckinAction
                                    evt={evt.data}
                                    editable={this.state.checkinAction}
                                    editableChange={this.editableChange}/>

                                <EvtViewOrganizerCheckinAction
                                    evt={evt.data}
                                    editable={this.state.organizerCheckinAction}
                                    editableChange={this.editableChange}/>
                                <EvtViewConfigForm
                                    type='sendAttendSignInConfirm'
                                    evt={evt.data}
                                    editable={this.state.sendAttendSignInConfirmEditable}
                                    confDesArr={[
                                        evtConfigDes.sendAttendSignInConfirm,
                                    ]}
                                    editableStatePropName="sendAttendSignInConfirmEditable"
                                    editableChange={this.editableChange}/>
                                <EvtViewConfigForm
                                    type='sendAllotReceiver'
                                    evt={evt.data}
                                    editable={this.state.sendAllotReceiverEditable}
                                    confDesArr={[
                                        evtConfigDes.sendAllotReceiver,
                                    ]}
                                    editableStatePropName="sendAllotReceiverEditable"
                                    editableChange={this.editableChange}/>
                                <EvtViewCheckinCredit
                                    evt={evt.data}
                                    editable={this.state.checkinCredit}
                                    editableChange={this.editableChange}/>
                                <EvtViewCheckinMusic
                                    evt={evt.data}
                                    editable={this.state.checkinMusic}
                                    editableChange={this.editableChange}/>

                            </div>
                            <div className="evt-banner-area area-turn">
                                <EvtViewConfigForm
                                    evt={evt.data}
                                    editable={this.state.checkinConfigEditable}
                                    confDesArr={[
                                        evtConfigDes.allowRepeatCheckin,
                                        evtConfigDes.allowDirectCheckin,
                                        evtConfigDes.allowUniqueFieldCheckin,
                                        evtConfigDes.enableFindTicketCaptcha,
                                        evtConfigDes.allowUniqueFieldQuickCheckin,
                                        evtConfigDes.allowUniqueFieldLikeCheckin,
                                        evtConfigDes.approveCheckin,
                                        evtConfigDes.onlyWxCheckIn,
                                        evtConfigDes.enablePositionRecord,
                                  
                                    ]}
                                    editableStatePropName="checkinConfigEditable"
                                    editableChange={this.editableChange}/>
                            </div>
                        </div>


                    </Tabs.TabPane>

                    <Tabs.TabPane tab="二维码" key="qrcode">
                        <Collapse bordered={false} activeKey={['1', '2']}>
                            <Collapse.Panel key="1" header={
                                <div>
                                    <span>报名二维码&nbsp;
                                        {/*<Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                            <div style={{maxHeight:700,overflow:'auto'}}>
                                                <img style={{width: 450}} src='https://img.qdj8.cn/11.jpg'/>
                                            </div>
                                        }>
                                             <span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                        </Tooltip>*/

                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                活动详情，报名和找回报名信息二维码，编辑活动该二维码不会改变，会员可以更换二维码中间的LOGO
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>

                                        }
                                    </span>
                                    <div className="toolbar-right"
                                    ><Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}} onClick={(e) => {
                                        e.stopPropagation();
                                        this.state.vaild ? this.editableChange("qrcodeEditable", true) : this.pstView.show();

                                    }}>更换二维码LOGO&nbsp;</Button>
                                        {/*<Button size="small" onClick={()=>window.open('https://www.kancloud.cn/seven_qdj/qdj_detail01/769879')} icon="question-circle-o" />*/}
                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                会员可以替换二维码中间的小LOGO <a href="https://www.kancloud.cn/seven_qdj/qdj_help_201808/769879" target="_Blank" >  详细帮助</a>
                                            </div>
                                        }>
                                            <Icon style={{marginLeft:5}} type="question-circle-o"/>
                                        </Tooltip>
                                    </div>
                                </div>}
                            >
                                <EvtViewQrcodeForm
                                    evt={evt.data}
                                    editable={this.state.qrcodeEditable}
                                    editableStatePropName="qrcodeEditable"
                                    editableChange={this.editableChange}/>


                            </Collapse.Panel>
                            <Collapse.Panel key="2" header={
                                <div>
                                    <span>签到二维码{evt.data.checkinpoints && evt.data.checkinpoints.length > 0 ? `（${evt.data.checkinpoints.length}）` : ''}
                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                参与人扫签到点二维码进行签到，一个活动可以创建多个签到二维码，在「签到」新增一个签到点，这里自动生成一个签到二维码，可以下载静态码和启动动态码，一旦创建，编辑签到点属性二维码不会改变
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>
                                    <div className="toolbar-right">
                                        {/* <Button type="primary" size="small" ghost style={{marginLeft: "7px", fontSize: "12px"}}>更换二维码LOGO</Button>*/}
                                    </div>
                                </div>}>
                                <EvtViewCheckinpointQrcode
                                    evt={evt.data}
                                    editable={this.state.checkinpointQrcodeEditable}
                                    editableStatePropName={"checkinpointQrcodeEditable"}
                                    editableChange={this.editableChange}/>
                            </Collapse.Panel>
                        </Collapse>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="LOGO" key="other">
                        <EvtViewPromoteForm
                            evt={evt.data}
                            vaild={this.state.vaild}
                            show={()=>this.pstView.show()}
                            editable={this.state.promoteEditable}
                            editableStatePropName={"promoteEditable"}
                            editableChange={this.editableChange}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="客服" key="wxcontact">
                        <EvtViewWxContactForm
                            evt={evt.data}
                            editable={this.state.wxContactEditable}
                            editableStatePropName={"wxContactEditable"}
                            editableChange={this.editableChange}/>
                    </Tabs.TabPane>
                </Tabs>

                <PurchaseServiceTips ref={(pst) => {
                    this.pstView = pst
                }}/>
            </Spin>
        );
    }
}


EvtView.contextTypes = {}

EvtView.defaultProps = {
    evtId: "",
    tabsActiveKey: "detail",
    inEditMode: () => null,
}

EvtView.propTypes = {}

const mapStateToPorps = state => {
    const evt = state.evt;
    const cmEnums = state.cmEnums;
    return {evt, cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
    replaceEvtInEvts: bindActionCreators(replaceEvtInEvts, dispatch),

});

export default connect(mapStateToPorps, mapDispatchToProps, null, {withRef: true})(EvtView);


// WEBPACK FOOTER //
// ./src/containers/evt/EvtView.jsx